export function sortList(list, sort) {
  const sorted = _(list).sortBy(it => {
    let field = _(it).lookup(sort.field);
    if (!field) {
      return "";
    }
    return field;
  });
  if (sort.ascending) {
    return sorted;
  } else {
    return sorted.reverse();
  }
}
